<script>
	//export let name;
	import Grid from "svelte-grid-responsive";
</script>


<main>
    <Grid container gutter={12}>
	  <Grid xs={12} md={12} lg={12}>
	    <!--a href="https://github.com/andrelmlins/svelte-grid-responsive">Svelte Grid Responsive</a-->    
		<!--h1>Hello {name}!</h1-->
	    <h1>Regal Peasant Productions</h1>
		<!--img src="https://imagedelivery.net/M-hNcUVb3g5noHADsiQNwQ/bae78d1d-ead6-48b4-3855-968e45b87100/public" alt='One Tube' class="responsive"-->
		<iframe style="border-radius:12px" src="https://open.spotify.com/embed/playlist/6NJa5uYVQOK1Oat9go1Lof?utm_source=generator" 
		    width="100%" 
			height="380" 
			frameBorder="0" 
			allowfullscreen="" 
			allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture">
		</iframe>
	  </Grid>
    </Grid>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 100%;
		margin: 0 auto;
	}

	h1 {
		/*color: #ff3e00;*/
		color: #2e8b57;
		font-size: 4em;
		font-weight: 100;
	}

	.responsive {
	    max-width: 100%;
		max-height: 100%;
	    margin: auto;
	}

	/*@media (min-width: 240px) {
		main {
			max-width: none;
		}
	}*/
</style>